import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'

import NewsContent from './NewsContent'

const styles = {
  cardStyle: {
    width: '100%'
  },
  cardContentStyle: {
    display: 'flex',
    flexDirection: 'row',
    padding: '16px 0 18px',
    margin: '0 16px',
    borderBottom: '1px solid #f0f1f2'
  },
  containerStyle: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  }
}

const NotificationMenuItem = ({ date, headline, text, isUnread, classes }) => {
  return (
    <Card className={classes.cardStyle} elevation={0}>
      <CardContent className={classes.cardContentStyle}>
        <NewsContent
          isPreview
          date={date}
          headline={headline}
          text={text}
          isUnread={isUnread}
        />
      </CardContent>
    </Card>
  )
}

export default withStyles(styles)(NotificationMenuItem)



// WEBPACK FOOTER //
// ./src/components/NotificationMenuItem.js